import { AccessesScreen } from "@components/Accesses/Screen";

export default AccessesScreen;
